import { Component } from 'react';

import type { ErrorInfo, ReactNode } from 'react';

/**
 * Ограждение от падений в отрисовке.
 *
 * Без него ошибка в компоненте гасит всё дерево, и остаётся пустая белая
 * страница — состояние, по которому невозможно понять вообще ничего. Так и
 * случилось при первой проверке этапа 9 в браузере: причина была в выборке,
 * уводившей React в бесконечную перерисовку, а на экране не было ни строчки.
 */

interface BoundaryState {
  error: Error | undefined;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, BoundaryState> {
  override state: BoundaryState = { error: undefined };

  static getDerivedStateFromError(error: Error): BoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('приложение упало', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (error === undefined) return this.props.children;

    return (
      <main className="boot">
        <h1>Onlap сломался</h1>
        <p>{error.message}</p>
        <p>Подробности — в консоли браузера. Данные на месте: они в локальной базе.</p>
        <button type="button" onClick={() => globalThis.location.reload()}>
          Перезагрузить
        </button>
      </main>
    );
  }
}
